var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"childref",staticClass:"google-map new-updated-design"},[_c('div',{staticClass:"map-container full-screen",attrs:{"id":"mapContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }